module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-users text-dark"
  }, [_c('div', {
    staticClass: "school-users__header"
  }, [_c('div', {
    staticClass: "school-users__header__text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.school_users.title')))]), _vm._v(" "), (_vm.isDK) ? _c('p', {
    staticClass: "do-pill do-pill--yellow school-users__intro"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.school_users.stil_intro')) + "\n        "), _c('a', {
    attrs: {
      "href": "https://viden.stil.dk/pages/viewpage.action?pageId=161059151",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.stil_read_more')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "school-users__header__actions"
  }, [(_vm.isDK) ? _c('a', {
    staticClass: "do-bttn",
    attrs: {
      "href": _vm.stilImportUrl
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.stil_import')))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "do-bttn",
    attrs: {
      "href": _vm.mergeUsersUrl
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.merge_users')))]), _vm._v(" "), _c('a', {
    staticClass: "do-bttn",
    attrs: {
      "href": _vm.transferCalendarUrl
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.transfer_calendar')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.create')))])])]), _vm._v(" "), _c('div', {
    staticClass: "school-users__toolbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "d-input school-users__search",
    attrs: {
      "type": "search",
      "placeholder": _vm.$t('vue2.school_users.search_placeholder')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('span', {
    staticClass: "school-users__count"
  }, [_vm._v(_vm._s(_vm.countLabel))]) : _vm._e()]), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : _c('table', {
    staticClass: "do-table do-table--striped school-users__table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "school-users__cell--photo"
  }), _vm._v(" "), _c('th', {
    staticClass: "school-users__cell--initials school-users__sortable",
    on: {
      "click": function($event) {
        return _vm.setSort('initials')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.school_users.initials')) + " "), _c('span', {
    staticClass: "school-users__sort"
  }, [_vm._v(_vm._s(_vm.sortIndicator('initials')))])]), _vm._v(" "), _c('th', {
    staticClass: "school-users__cell--name school-users__sortable",
    on: {
      "click": function($event) {
        return _vm.setSort('name')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.school_users.name')) + " "), _c('span', {
    staticClass: "school-users__sort"
  }, [_vm._v(_vm._s(_vm.sortIndicator('name')))])]), _vm._v(" "), _c('th', {
    staticClass: "school-users__cell--login"
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.login')))]), _vm._v(" "), _c('th', {
    staticClass: "school-users__cell--phone"
  }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.phone')))]), _vm._v(" "), _c('th', {
    staticClass: "school-users__cell--seen school-users__sortable",
    on: {
      "click": function($event) {
        return _vm.setSort('last_seen')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.school_users.last_seen')) + " "), _c('span', {
    staticClass: "school-users__sort"
  }, [_vm._v(_vm._s(_vm.sortIndicator('last_seen')))])]), _vm._v(" "), _c('th', {
    staticClass: "school-users__cell--actions"
  })])]), _vm._v(" "), _c('tbody', [(_vm.visibleUsers.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(_vm._s(_vm.search ? _vm.$t('vue2.school_users.no_results') : _vm.$t('vue2.school_users.none')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.visibleUsers), function(user) {
    return _c('tr', {
      key: user.id,
      staticClass: "school-users__row",
      on: {
        "click": function($event) {
          return _vm.openEdit(user)
        }
      }
    }, [_c('td', {
      staticClass: "school-users__cell--photo"
    }, [_c('img', {
      staticClass: "school-users__avatar",
      attrs: {
        "src": user.default_thumb_url,
        "alt": user.name,
        "width": "36",
        "height": "36"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "school-users__cell--initials"
    }, [_vm._v(_vm._s(user.initials))]), _vm._v(" "), _c('td', {
      staticClass: "school-users__cell--name"
    }, [_c('span', {
      staticClass: "school-users__name"
    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), (user.employee_id) ? _c('span', {
      staticClass: "school-users__sub"
    }, [_vm._v(_vm._s(_vm.$t('vue2.school_users.employee_id')) + " " + _vm._s(user.employee_id))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "school-users__cell--login"
    }, _vm._l((_vm.logins(user)), function(login) {
      return _c('div', {
        key: login.type,
        staticClass: "school-users__login"
      }, [_c('span', {
        staticClass: "school-users__login__type"
      }, [_vm._v(_vm._s(login.type))]), _vm._v(" " + _vm._s(login.value) + "\n          ")])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "school-users__cell--phone"
    }, [_vm._v(_vm._s(_vm.formatPhone(user.phone)))]), _vm._v(" "), _c('td', {
      staticClass: "school-users__cell--seen"
    }, [_c('span', {
      class: {
        'school-users__never': !user.last_seen
      }
    }, [_vm._v(_vm._s(_vm.lastSeen(user)))])]), _vm._v(" "), _c('td', {
      staticClass: "school-users__cell--actions",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('DDropdown', {
      attrs: {
        "isShowDots": false,
        "isBottomStart": false,
        "appendToBody": false,
        "propOffset": [0, 4],
        "closeFromProp": _vm.closeActionsMenu
      }
    }, [_c('button', {
      staticClass: "do-bttn do-bttn--small",
      attrs: {
        "slot": "title",
        "type": "button"
      },
      slot: "title"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.school_users.actions')) + " "), _c('span', {
      staticClass: "icon-arrow-down5"
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, _vm._l((_vm.actions), function(action) {
      return _c('li', {
        key: action.key,
        on: {
          "click": function($event) {
            return _vm.runAction(action, user)
          }
        }
      }, [_c('span', {
        class: action.icon
      }), _vm._v(" " + _vm._s(action.label) + "\n              ")])
    }), 0)])], 1)])
  })], 2)]), _vm._v(" "), (_vm.editingUser) ? _c('SchoolUserModal', {
    attrs: {
      "schoolId": _vm.schoolId,
      "user": _vm.editingUser
    },
    on: {
      "saved": _vm.onSaved,
      "imageChanged": _vm.readList,
      "close": function($event) {
        _vm.editingUser = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a3b379c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SchoolUsers/SchoolUsers.vue
// module id = 1865
// module chunks = 1